'use client';

import type { PropsWithChildren } from 'react';

import { Button, Icon } from '@polyseme/design-system';
import { cn } from '@polyseme/utils/cn/cn-utils';
import { useIsInViewport } from '@polyseme/utils/hooks/use-is-in-viewport/use-is-in-viewport';
import { useTranslations } from 'next-intl';

import { useScrollToContactCard } from './scroll-to-contact-card-context';

export const FloatingCta = ({ children }: PropsWithChildren) => {
  const t = useTranslations('landing.retraite.floatingCta');
  const { hasScrolledPast, isInViewport, ref } = useIsInViewport();
  const scrollToContactCard = useScrollToContactCard();

  return (
    <>
      <div ref={ref}>{children}</div>
      <Button
        className={cn(
          'fixed bottom-2 left-1/2 -translate-x-1/2 cursor-pointer sm:hidden',
          {
            hidden: isInViewport || hasScrolledPast,
          }
        )}
        onClick={scrollToContactCard}
      >
        {t('label')}
        <Icon name="arrow-down" />
      </Button>
    </>
  );
};
